import React from 'react';
import PropTypes from 'prop-types';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import TeamSearch from '../TeamSearch';
import { HeaderWrapper, Title, Categories, Category, CategorySelect } from './styled';

const Header = ({
  title,
  team,
  categories,
  onCategorySelect,
  selectedCategory,
  onMemberSelect,
  scrollToMember,
  hideOnMobile = false,
  showSearch = true
}) => {
  const { width: windowWidth } = useWindowSize();
  const isMobile = windowWidth < SCREEN_SIZES.tabletPortrait;

  if (isMobile && hideOnMobile) {
    return null;
  }

  return (
    <>
      <HeaderWrapper>
        <Title>{title}</Title>

        <Categories>
          {categories.map((category) => (
            <Category
              key={category}
              selected={selectedCategory === category}
              onClick={() => onCategorySelect(category)}
            >
              {category}
            </Category>
          ))}
        </Categories>

        <CategorySelect
          options={categories.map((category) => ({ value: category, label: category }))}
          onChange={(selection) => onCategorySelect(selection.value)}
          value={selectedCategory}
          variant="global"
        />
      </HeaderWrapper>
      {showSearch && (
        <TeamSearch
          team={team}
          onMemberSelect={(member) =>
            isMobile ? scrollToMember(member) : onMemberSelect(member)
          }
        />
      )}
    </>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  team: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  onCategorySelect: PropTypes.func.isRequired,
  selectedCategory: PropTypes.string.isRequired,
  onMemberSelect: PropTypes.func,
  scrollToMember: PropTypes.func,
  hideOnMobile: PropTypes.bool,
  showSearch: PropTypes.bool
};

export default Header;
